import { useFinancialGroupQuery } from '@/app/services/financialGroupApi';
import FinalBalance from '@/components/costTracking/finalBalance/Finalbalance';
import InitialBalance from '@/components/costTracking/initialBalance/InitialBalance';
import RelatedServices from '@/components/costTracking/Relatedservices/RelatedServices';
import Rubric from '@/components/costTracking/Rubric';
import { useFinancialGroup } from '@/context/FinancialGroup';
import { useFinancialSubGroup } from '@/context/FinancialSubGroup';
import { Box, FormControl, MenuItem, Select, SelectChangeEvent, Typography, useTheme } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

function CostTrackingDetails() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { code, category } = useParams();
  const { t } = useTranslation(['costTracking', 'common']);

  const { selectedFinancialGroup, setSelectedFinancialGroup } = useFinancialGroup();
  const { setSelectedFinancialSubGroup } = useFinancialSubGroup();

  const { data } = useFinancialGroupQuery();

  useEffect(() => {
    if (data && category) {
      const found = data.find((c) => c.name === category);
      if (found) {
        setSelectedFinancialGroup(found);
      }
    } else if (data && data.length > 0 && code) {
      navigate(`/projects/${code}/cost-tracking/${encodeURIComponent(data[0].name)}`, {
        replace: true,
      });
    }
  }, [category, code, data, navigate, setSelectedFinancialGroup]);

  const handleCategoryChange = (e: SelectChangeEvent<string>) => {
    const selectedCode = e.target.value;
    const selected = data && data.find((c) => c.code === selectedCode);
    if (selected) {
      setSelectedFinancialGroup(selected);
      setSelectedFinancialSubGroup(undefined);
      if (code) {
        navigate(`/projects/${code}/cost-tracking/${encodeURIComponent(selected.name)}`);
      }
    }
  };

  const renderCategoriaComponent = () => {
    switch (selectedFinancialGroup?.code) {
      case 'FINALBALANCE':
        return <FinalBalance group={selectedFinancialGroup} />;
      case 'INITIALBALANCE':
        return <InitialBalance group={selectedFinancialGroup} />;
      case 'RELATEDSERVICES':
        return <RelatedServices group={selectedFinancialGroup} />;
      default:
        return <Rubric group={selectedFinancialGroup} />;
    }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <Typography component="p" variant="h1">
          {t('common:category')}
        </Typography>
        <FormControl sx={{ width: theme.spacing(30) }}>
          <Select
            displayEmpty
            value={selectedFinancialGroup?.code}
            onChange={handleCategoryChange}
            sx={{ height: 32, fontSize: 14 }}
            renderValue={(selected) => {
              if (!selected) return category;
              const found = data?.find((item) => item.code === selected);
              return found ? t(found.name) : category;
            }}
          >
            {data &&
              data.map((item) => (
                <MenuItem key={item.id} value={item.code} sx={{ fontSize: 13 }}>
                  {t(item.name)}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Box>

      {/* Renders the component based on the URL header */}
      <Box sx={{ mt: 1 }}>{renderCategoriaComponent()}</Box>
    </Box>
  );
}

export default CostTrackingDetails;
